import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getStatisticsURL } from '../api';
import moment from 'jalali-moment'

// initial state
export const initialState = {
  loading: false,
  error: false,
  items: []
};

// our slice
const statisticsSlice = createSlice({
  name: "statistics",
  initialState,
  reducers: {
    setStatisticsLoading: (state) => {
      state.loading = true;
    },
    setLoadingFalse: (state) => {
      state.Loading = false;
    },
    setStatisticsItems: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.items.push(...payload);
    },
    setStatisticsError: (state) => {
      state.error = true;
    },
    clearStatisticsItems: (state) => {
      state.items = [];
    },
    
    clearStatisticsData: (state) => {
      
      state.loading = false;
      state.error = false;
      state.items = [];

    }
  },
});

// export the actions
export const { setStatisticsLoading, setStatisticsItems, setStatisticsError, clearStatisticsData,clearStatisticsItems ,clearStatisticsFilters, setLoadingFalse } = statisticsSlice.actions;

// export the selector (".items" being same as in slices/index.js's "items: something")
export const itemsSelector = (state) => state.items;

// export the default reducer
export default statisticsSlice.reducer;


// fetch all items
export function fetchStatistics(input) {
  return async (dispatch) => {

    dispatch(clearStatisticsItems());

    dispatch(setStatisticsLoading());

    await axios.post(getStatisticsURL()+'?username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token, {timeout: 670000})
      .then(response => {
          console.log(response.data);
          dispatch(setStatisticsItems(response.data));
      }).catch(function (err) {
        console.log("error in Fetching Statistics");
        dispatch(setStatisticsError());
      }).finally(()=> {
        dispatch(setLoadingFalse());
      });
  
  };
}
export function clearStatistics() {
  return async (dispatch) => {


      dispatch(clearStatisticsData());
   
  };
}